import * as React from 'react';
import { IDeck } from '../../interfaces/IShipDetailPageData';
import CustomSelect from '../CustomSelect/CustomSelect';
export interface IDeckProps {
    title?: string;
    decks: IDeck[];
}

const valueComponent = (props) => {
    return (
        <div className="option-selected">
            <span>{props.value.label}</span>
        </div>
    );
};

const optionComponent = (props) => {
    const handleClick = () => props.onSelect(props.option);

    return (
        <div onClick={handleClick} className="option">
            <span>{props.option.label}</span>
        </div>
    );
};

export const Decks = (props: IDeckProps) => {
    const [currentDeckTitle, setCurrentDeckTitle] = React.useState(() => props.decks?.[0].title);

    const deck = props.decks.find((deck) => deck.title === currentDeckTitle) ?? props.decks?.[0];

    const selectDeck = (event) => {
        setCurrentDeckTitle(event.value);
    };
    const options = props.decks.map((deck) => {
        return {
            label: deck.title,
            value: deck.title,
        };
    });
    return (
        <div className="decksContainer">
            {!!props.title && <h4>{props.title}:</h4>}
            <div className="decksContainer__selectContainer">
                <CustomSelect
                    value={currentDeckTitle}
                    valueComponent={valueComponent}
                    options={options}
                    optionComponent={optionComponent}
                    onChange={selectDeck}
                    clearable={false}
                    searchable={false}
                />
            </div>

            <div className="imageContainer">
                <img src={deck.image} alt="deck plan" />
            </div>
        </div>
    );
};
